import { ChangeDetectorRef, DestroyRef, ElementRef, forwardRef, inject, TemplateRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModelFormServiceFactory } from '../form-service';
import { ModelBasedControlValueAccessor } from '../model-based-control-value-accessor';
import { FilterFormService } from './filter-form.service';
import { takeWhileAlive } from '@core/frontend-shared/utils';
import { BehaviorSubject } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { InstructionOutletDirective } from '../instruction-outlet/instruction-outlet.directive';
import { UiButtonComponent } from '@common/ui/frontend-shared/button';
import { UiInputGroupComponent } from '@common/ui/frontend-shared/input-group';
import * as i0 from "@angular/core";
import * as i1 from "../form-service";
import * as i2 from "@angular/forms";
const _c0 = (a0, a1, a2) => ({
  instruction: a0,
  formGroup: a1,
  formControlName: a2
});
function FilterFieldsetComponent_Conditional_0_Conditional_3_For_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FilterFieldsetComponent_Conditional_0_Conditional_3_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 2);
    i0.ɵɵtemplate(1, FilterFieldsetComponent_Conditional_0_Conditional_3_For_2_ng_container_1_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const instr_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("formGroup", ctx_r1.formService.formGroup);
    i0.ɵɵadvance();
    i0.ɵɵproperty("instructionOutlet", i0.ɵɵpureFunction3(2, _c0, instr_r1, ctx_r1.formService.formGroup, instr_r1.config.formControlName));
  }
}
function FilterFieldsetComponent_Conditional_0_Conditional_3_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function FilterFieldsetComponent_Conditional_0_Conditional_3_Conditional_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      i0.ɵɵnextContext(2);
      const formControl_r4 = i0.ɵɵreference(2);
      return i0.ɵɵresetView(formControl_r4.reset());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("label", ctx_r1.showResetLabel ? ctx_r1.resetLabel : undefined);
  }
}
function FilterFieldsetComponent_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ui-input-group", 3);
    i0.ɵɵrepeaterCreate(1, FilterFieldsetComponent_Conditional_0_Conditional_3_For_2_Template, 2, 6, "ng-container", 2, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵconditionalCreate(3, FilterFieldsetComponent_Conditional_0_Conditional_3_Conditional_3_Template, 1, 1, "button", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("breakpoint", ctx_r1.inputGroupBreakpoint)("rounded", ctx_r1.rounded);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.instructions);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.showResetButton && ctx_r1.canReset ? 3 : -1);
  }
}
function FilterFieldsetComponent_Conditional_0_Conditional_4_For_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FilterFieldsetComponent_Conditional_0_Conditional_4_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 2);
    i0.ɵɵtemplate(1, FilterFieldsetComponent_Conditional_0_Conditional_4_For_2_ng_container_1_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const instr_r5 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("formGroup", ctx_r1.formService.formGroup);
    i0.ɵɵadvance();
    i0.ɵɵproperty("instructionOutlet", i0.ɵɵpureFunction3(2, _c0, instr_r5, ctx_r1.formService.formGroup, instr_r5.config.formControlName));
  }
}
function FilterFieldsetComponent_Conditional_0_Conditional_4_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵlistener("click", function FilterFieldsetComponent_Conditional_0_Conditional_4_Conditional_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      i0.ɵɵnextContext(2);
      const formControl_r4 = i0.ɵɵreference(2);
      return i0.ɵɵresetView(formControl_r4.reset());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("label", ctx_r1.showResetLabel ? ctx_r1.resetLabel : undefined);
  }
}
function FilterFieldsetComponent_Conditional_0_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵrepeaterCreate(1, FilterFieldsetComponent_Conditional_0_Conditional_4_For_2_Template, 2, 6, "ng-container", 2, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵconditionalCreate(3, FilterFieldsetComponent_Conditional_0_Conditional_4_Conditional_3_Template, 1, 1, "button", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.instructions);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.showResetButton && ctx_r1.canReset ? 3 : -1);
  }
}
function FilterFieldsetComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "form", 2, 0);
    i0.ɵɵconditionalCreate(3, FilterFieldsetComponent_Conditional_0_Conditional_3_Template, 4, 3, "ui-input-group", 3);
    i0.ɵɵconditionalCreate(4, FilterFieldsetComponent_Conditional_0_Conditional_4_Template, 4, 1, "div", 4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r1.formService.formGroup);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.grouped ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.grouped ? 4 : -1);
  }
}
export const FILTER_FIELDSET_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => FilterFieldsetComponent),
  multi: true
};
export let FilterFieldsetComponent = /*#__PURE__*/(() => {
  class FilterFieldsetComponent extends ModelBasedControlValueAccessor {
    set _value(value) {
      this.formService?.setValue(value);
      this.value = value;
      this.calculateCanReset(value);
    }
    set instructions(instructions) {
      this.directInstructions$.next(instructions.map(f => {
        // formService will be initialized using setupUsingInstructions.
        // that setup routine already sets default values based on a "value" property within each field.
        // so we just have to map the definable defaultValue prop to "value" prop.
        const enhanced = f;
        enhanced.value = f.config.defaultValue || null;
        return enhanced;
      }));
    }
    get instructions() {
      return this.directInstructions$.getValue();
    }
    constructor(cd, formServiceFactory) {
      super(cd, formServiceFactory);
      this.formServiceFactory = formServiceFactory;
      this.destroyRef = inject(DestroyRef);
      this._model = {};
      this.defaultModel = {};
      this.rounded = true;
      this.grouped = true;
      this.showResetButton = true;
      this.inputGroupBreakpoint = -1;
      this.showResetLabel = false;
      this.resetLabel = 'Löschen';
      this.canReset = false;
      // Note that FilterFieldset does NOT inherit SimpleFieldset!
      this.directInstructions$ = new BehaviorSubject(null);
      this.innerFormData = {};
      this.submitShortcut = 'ctrl+enter';
    }
    _tryToInitialize() {
      if (this.initialized) return;
      // configurate formService to work without Model/Factory/Service
      this.createDefaultFormService();
      this.formService.setupUsingInstructions(this.instructions);
      this._executeInitialization({
        initializeFormService: true
      });
    }
    bindFormServiceObservables() {
      super.bindFormServiceObservables();
      this.formService.valueChanges$.pipe(takeWhileAlive(this.destroyRef)).subscribe(value => this.calculateCanReset(value));
    }
    createDefaultFormService() {
      this.formService$.next(this.formServiceFactory.useDestroyRef(this.destroyRef).createUninitialized(FilterFormService));
      if (this.debug) this.formService.debug();
    }
    submit() {
      if (this.formService) this.formService.save();
    }
    onEnter(event) {
      const isCtrl = event.ctrlKey;
      if (this.submitShortcut === 'ctrl+enter') {
        if (isCtrl) this.submit();
      } else {
        this.submit();
      }
    }
    calculateCanReset(value) {
      const keys = Object.keys(value);
      this.cd.markForCheck();
      for (let i = 0; i < keys.length; i++) {
        if (typeof value[keys[i]] !== 'undefined' && value[keys[i]] !== null) {
          this.canReset = true;
          return;
        }
      }
      this.canReset = false;
    }
    static {
      this.ɵfac = function FilterFieldsetComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FilterFieldsetComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.ModelFormServiceFactory));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: FilterFieldsetComponent,
        selectors: [["filter-fieldset"]],
        hostVars: 2,
        hostBindings: function FilterFieldsetComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("has-active-filters", ctx.canReset);
          }
        },
        inputs: {
          rounded: "rounded",
          grouped: "grouped",
          showResetButton: "showResetButton",
          inputGroupBreakpoint: "inputGroupBreakpoint",
          showResetLabel: "showResetLabel",
          resetLabel: "resetLabel",
          _value: [0, "value", "_value"],
          instructions: "instructions",
          title: "title",
          innerForm: "innerForm",
          innerFormData: "innerFormData",
          submitShortcut: "submitShortcut"
        },
        features: [i0.ɵɵProvidersFeature([FILTER_FIELDSET_VALUE_ACCESSOR]), i0.ɵɵInheritDefinitionFeature],
        decls: 2,
        vars: 3,
        consts: [["formControl", "ngForm"], [1, "ui-toolbar-group-right"], [3, "formGroup"], [1, "filter-fieldset-fields", 3, "breakpoint", "rounded"], [1, "filter-fieldset-fields"], ["e2e-filter-bar-reset-button", "", "uiButton", "", "icon", "times", "title", "Filter zur\u00FCcksetzen", 1, "button-reset", "ui-button-contrast", 3, "label"], [4, "instructionOutlet"], ["e2e-filter-bar-reset-button", "", "uiButton", "", "icon", "times", "title", "Filter zur\u00FCcksetzen", 1, "button-reset", "ui-button-contrast", 3, "click", "label"], ["e2e-filter-bar-reset-button", "", "uiButton", "", "icon", "times", "title", "Filter zur\u00FCcksetzen", 1, "button-reset", 3, "label"], ["e2e-filter-bar-reset-button", "", "uiButton", "", "icon", "times", "title", "Filter zur\u00FCcksetzen", 1, "button-reset", 3, "click", "label"]],
        template: function FilterFieldsetComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, FilterFieldsetComponent_Conditional_0_Template, 5, 3, "div", 1);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵconditional(i0.ɵɵpipeBind1(1, 1, ctx.initialized$) && (ctx.instructions == null ? null : ctx.instructions.length) > 0 ? 0 : -1);
          }
        },
        dependencies: [FormsModule, i2.ɵNgNoValidate, i2.NgControlStatusGroup, ReactiveFormsModule, i2.FormGroupDirective, UiInputGroupComponent, InstructionOutletDirective, UiButtonComponent, AsyncPipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return FilterFieldsetComponent;
})();